import AnchorDecorator from "./anchor.js";
import LinkDecorator from "./link.js";
const nodeViewDecorators = [
  LinkDecorator,
  AnchorDecorator
];
export {
  nodeViewDecorators
};
//# sourceMappingURL=index.js.map
